import React, { FC } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { BusinessPostsGrid } from '../BusinessPostsGrid/BusinessPostsGrid';
import { DiscoveryPostsGrid } from '../DiscoveryPostsGrid/DiscoveryPostsGrid';
import { PostDetailsLocationState } from '../PostDetails';
import { PostsGridProps } from './types';

export const PostsGrid: FC<PostsGridProps> = (props) => {
    const locationState = useLocation().state as PostDetailsLocationState | null;
    const params = useParams();
    const postId = params.postId!;

    if (locationState?.fromBusinessId) {
        return <BusinessPostsGrid fromBusinessId={locationState.fromBusinessId} {...props} />;
    }

    return <DiscoveryPostsGrid postId={postId} dialogName={locationState?.dialogName} {...props} />;
};
